export const normalizeInternationalCurrencyFormat = (formattedAmount, currency = "USD") => {
  // normalize currency outputs across browser versions
  // ('MX$1.00', 'MXN') => "MXN $1.00",
  // ('MXN$1.00', 'MXN') => "MXN $1.00",
  // ('MXN $1.00', 'MXN') => "MXN $1.00",
  // ('$1.00', 'MXN') => "MXN $1.00",
  // ('$1.00', 'USD') => "MXN $1.00",
  // ('$1.00') => "MXN $1.00",
  return formattedAmount.toString().replace(/([A-Z]{1,3}\s?)?([\S]\S*)/, (match, currencyCode, amount) => { // found that the Intl API can return currency abbreviations between 1 and 3 characters
    return currency === 'USD' ? amount : `${currency} ${amount}`;
  });
};

const getDefaultNumberFormatOptions = (currencyCode) => {
  switch(currencyCode){
    case 'JPY':
      return {
        // don't display any fractional digits since we are rounding to an integer
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      };
    default:
      return {};
  }
};

export const internationalCurrencyFormat = (num, {currency = 'USD', locale = 'en-US', ...otherOptions}) => {
  num = Number(num);

  const formattedNum = new Intl.NumberFormat(
    locale, // locale - refer to https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#Locale_identification_and_negotiation
    {
      style: 'currency',
      currency, // for currency codes list refer to https://www.currency-iso.org/en/home/tables/table-a1.html
      ...getDefaultNumberFormatOptions(currency),
      ...otherOptions,
    }, // options obj - refer to https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat#Parameters
  ).format(num);

  return normalizeInternationalCurrencyFormat(formattedNum, currency);
};

export const transformConvertedCurrency = (amount, currencyCode) => {
  switch(currencyCode){
    case 'JPY':
    case 'HUF':
      // these currencies don't support decimals
      return Math.ceil(amount);
    default:
      return amount;
  }
};

export const ceilingToFixed = (num, precision = 2) => {
  // round all currencies up to nearest hundredth
  precision = Math.pow(10, precision);
  return Math.ceil(num * precision) / precision;
};
